import { calcularQtdDependentesConjuge, validator19Ate64Anos, validator65anos, validatorAte18anos } from "./funcoesAuxiliaresZUP";



export class CorrenteCadastroZUP {
    constructor(dependentes, parentesco, categorias,valoresForm) {
        this.dependentes = dependentes;
        this.parentesco = parentesco;
        this.categorias = categorias
        this.arrayMsgsErro = []
        this.valoresForm = valoresForm
    }
    possuiConjuge() {
        const qtdDependentesConjugue = calcularQtdDependentesConjuge(this.dependentes);
        if (qtdDependentesConjugue === 1 && this.valoresForm.Parentesco.trim() === '10') {
            this.arrayMsgsErro.push('Este plano permite apenas 1 dependente do tipo cônjuge.')
        }
        return this;
    }
    conjugeSomenteSemValorAdicional(){
        const qtdDependentesConjugue = calcularQtdDependentesConjuge(this.dependentes);
        if (qtdDependentesConjugue === 0 &&
            this.valoresForm.Parentesco.trim() === '10' &&
            this.valoresForm.Categoria.trim() !== 'ZELO') {
            this.arrayMsgsErro.push('Dependente do tipo cônjuge só pode ser inserido sem valor adicional.')
        }
        return this;
    }
    outrosParentescosSemValorAdicional(){
        if (
            this.valoresForm.Parentesco.trim() !== '10' &&
            this.valoresForm.Categoria.trim() === 'ZELO') {
            this.arrayMsgsErro.push('É permitido apenas dependente do tipo cônjuge sem valor adicional.')
        }
        return this;
    }
    idadeAte18anos() {
        if (validatorAte18anos(this.valoresForm)) {
            this.arrayMsgsErro.push('Para dependentes até 18 anos, o adicional permitido é o PLENO ATÉ 18 ANOS.')
        }
        return this;
    }
    idadeEntre18a64anos() {
        if (validator19Ate64Anos(this.valoresForm)) {
            this.arrayMsgsErro.push('Para dependentes entre 19 e 64 anos, o adicional permitido é o PLENO ATÉ 64 ANOS.')
        }
        return this;
    }
    idadeMaiorIgual65anos() {
        if (validator65anos(this.valoresForm)) {
            this.arrayMsgsErro.push('Para dependentes acima de 65 anos, o adicional permitido é o PLENO MAIOR 65 ANOS.')
        }
        return this;
    }
    
}
  

